import { render, staticRenderFns } from "./AccountPreferenceCenter.vue?vue&type=template&id=62bc20fe&"
import script from "./AccountPreferenceCenter.vue?vue&type=script&lang=js&"
export * from "./AccountPreferenceCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports